<template>
    <settings-page :title="title" :description="description">
        <div class="text-setting">
            <settings-text
                :preview-text="headingPreviewText"
                label="H1"
                tag="h1"
                element-type="a-heading"
                @input="onInput"
                @preview-input="onPreviewInput"
            />

            <settings-text
                :preview-text="headingPreviewText"
                label="H2"
                tag="h2"
                element-type="a-heading"
                @input="onInput"
                @preview-input="onPreviewInput"
            />

            <settings-text
                :preview-text="headingPreviewText"
                label="H3"
                tag="h3"
                element-type="a-heading"
                @input="onInput"
                @preview-input="onPreviewInput"
            />

            <settings-text
                :preview-text="headingPreviewText"
                label="H4"
                tag="h4"
                element-type="a-heading"
                @input="onInput"
                @preview-input="onPreviewInput"
            />

            <settings-text
                :preview-text="headingPreviewText"
                label="H5"
                tag="h5"
                element-type="a-heading"
                @input="onInput"
                @preview-input="onPreviewInput"
            />

            <settings-text
                :preview-text="headingPreviewText"
                label="H6"
                tag="h6"
                element-type="a-heading"
                @input="onInput"
                @preview-input="onPreviewInput"
            />

            <settings-text
                :preview-text="paragraphPreviewText"
                label="P"
                tag="p"
                element-type="a-text-multi-line"
                multiline
                @input="onInput"
                @preview-input="onPreviewInput"
            />
        </div>
    </settings-page>
</template>

<script>
import SettingsPage from '@/components/settings/shared/settings-page';
import SettingsText from '@/components/settings/shared/settings-text';

export default {
    name: 'settings-html-defaults',
    components: { SettingsPage, SettingsText },

    data() {
        return {
            title: 'Default Element Fonts',
            description: 'You can define your default element fonts on the left, and preview their output on the right.',
            headingPreviewText: 'The quick brown fox',
            paragraphPreviewText: 'A parturient hac consectetur mi velit condimentum taciti libero primis tortor ullamcorper tellus blandit erat. Scelerisque facilisis adipiscing quam adipiscing amet facilisi volutpat neque condimentum ullamcorper tristique ullamcorper a ad ad etiam.',
        };
    },

    methods: {
        onInput(data) {
            this.$emit('input', 'text', data);
        },

        onPreviewInput(tag, previewText) {
            if (tag === 'p') {
                this.paragraphPreviewText = previewText;
            } else {
                this.headingPreviewText = previewText;
            }
        },
    },
};
</script>
